import { Flex, Hide } from '@chakra-ui/react';

import { Header } from '../../components';

import { DataBuyer } from './DataBuyer';
import { DataMyProducts } from './DataMyProducts';

const ROOT_ENTITY = 'checkout/data';

export const Data = () => {
  return (
    <Flex
      flexDir="column"
      w="full"
      p={{ base: 0, lg: 5 }}
      maxH="100dvh"
      h="100%"
    >
      <Header
        currentStep={2}
        rootEntity={ROOT_ENTITY}
        cart={<DataMyProducts />}
      />

      <Flex
        gap={5}
        flexDir={{ base: 'column', lg: 'row' }}
        p={{ base: 4, lg: 0 }}
      >
        <Flex flexDir="column" gap={6} w="full">
          <DataBuyer />
        </Flex>

        <Hide below="lg">
          <DataMyProducts />
        </Hide>
      </Flex>
    </Flex>
  );
};
